// extracted by mini-css-extract-plugin
export default {"cardWrapper":"Price_cardWrapper__GoWn6","isColLg":"Price_isColLg__JljN5"};